import React, { lazy } from 'react'

const PermissionNonExclusiveRusPage = lazy(() =>
  import('./PermissionNonExclusiveRusPage')
)

export { PermissionNonExclusiveRusPage }
